// extracted by mini-css-extract-plugin
module.exports = {"HeroSection":"HeroSection_HeroSection__3ySa9","heroText":"HeroSection_heroText__3TvDB"};